
import { usePopup } from "@/context/PopupContext";
import React from "react";

export const usePopupManager = () => {
  const { showPopup, hidePopup, hideAllPopups } = usePopup();

  const showCouponPopup = (
    title?: string,
    message?: string,
    persistent = false
  ) => {
    return showPopup({
      type: "coupon",
      title,
      message,
      persistent,
    });
  };

  const showNotificationPopup = (
    title: string,
    message: string,
    persistent = false
  ) => {
    return showPopup({
      type: "notification",
      title,
      message,
      persistent,
    });
  };

  const showConfirmationPopup = (
    title: string,
    message: string,
    onConfirm: () => void,
    onCancel?: () => void,
    persistent = true
  ) => {
    const id = showPopup({
      type: "custom",
      component: (
        <div className="bg-white p-6 rounded-lg shadow-lg">
          <h2 className="text-xl font-semibold mb-2">{title}</h2>
          <p className="text-gray-700 mb-4">{message}</p>
          <div className="flex justify-end space-x-2">
            <button
              onClick={() => {
                hidePopup(id);
                onCancel?.();
              }}
              className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100"
            >
              İptal
            </button>
            <button
              onClick={() => {
                hidePopup(id);
                onConfirm();
              }}
              className="px-4 py-2 bg-primary text-white rounded hover:bg-primary/90"
            >
              Onayla
            </button>
          </div>
        </div>
      ),
      persistent,
    });
    return id;
  };

  const showCustomPopup = (
    component: React.ReactNode,
    persistent = false
  ) => {
    return showPopup({
      type: "custom",
      component,
      persistent,
    });
  };

  return {
    showCouponPopup,
    showNotificationPopup,
    showConfirmationPopup,
    showCustomPopup,
    hidePopup,
    hideAllPopups,
  };
};
